<!--template html-->
<template>
    <div v-if="message" class="gc-column-content message-editable dontsplit" :data-id="message.UniqueId" :id="'msg-'+idKey+'-'+message.UniqueId" :data-message="message.MessageId">
        <div class="gc-column-outline">
            <div class="gc-column-text">
                <img class="img-fluid" :class="imageClassName" v-if="hasImage" @load="imageLoaded" :src="message.ImageUrl" alt="Group Card Image" />
                <div class="gc-message-parent">
                    <span v-html="message.Message"></span>
                    <p class="text-right">- {{message.Name}}</p>
                </div>
            </div>
            <!-- gc-column-text -->
        </div>
    </div>
    <!-- gc-column-content -->
</template>
<!--template html-->
<!--script -->
<script>
    export default {
        name: 'GroupCardMessageRawV2',
        props: {
            message: Object,
            index: Number,
            columnType: Number,
            idKey: String
        },
        data: function () {
            return {
                imageClassName: "",
                hasImage: false
            }
        },
        mounted: function () {
            this.initMessage()
        },
        methods: {
            initMessage() {
                //checking if message has image
                if (this.message.ImageUrl) {
                    if (!(this.message.ImageUrl.indexOf("no_pic.jpg") > -1)) {
                        this.hasImage = true;
                    }
                }
                //if message has no image dont display
                if (!this.hasImage) {
                    this.$emit('update-parent', 1, this.message.UniqueId)
                    return false;
                }
            },
            imageLoaded(event) {
                if (this.columnType === 1) {
                    let image = event.target
                    if (image.naturalHeight > 0) {
                        //setting appropriate image class name for 1-column designs
                        if (this.imageClassName === "") {
                            if (((image.naturalWidth / image.naturalHeight) >= 1.5))
                                this.imageClassName = "gc-cover-image"
                            else
                                this.imageClassName = "gc-tile-image"
                        }
                    }
                    //image is loaded
                    this.$emit('update-parent', 1, this.message.UniqueId)
                } else if (this.columnType === 2) {
                    this.imageClassName = "gc-single-image-col-2"
                    //image is loaded
                    this.$emit('update-parent', 1, this.message.UniqueId)
                } else {
                    this.imageClassName = "gc-single-image-col-3"
                    //image is loaded
                    this.$emit('update-parent', 1, this.message.UniqueId)
                }
            }
        }
    }
</script>
<!--script -->
<!--Add "scoped" attribute to limit CSS to this component only-->
<style scoped>
</style>